import { get } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import render from './render'

function getTaxLabelKey(value) {
  if (value === true) {
    return 'true'
  }
  if (value === false) {
    return 'false'
  }
}

export default {
  name: 'RequisitesCard',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    title() {
      return get(this.value, 'data.legal.name') || get(this.value, 'title')
    },

    label() {
      const value = get(this.value, 'data.tax.vat')
      const result = getTaxLabelKey(value)
      if (result) {
        return this.getTranslate(`${Services.requisites}.vat.${result}`)
      }
    },

    legalFormValue() {
      return get(this.value, 'data.legal.opf')
    },
    taxNumberValue() {
      return get(this.value, 'data.legal.inn')
    },

    contactValue() {
      const fullName = [
        get(this.value, 'contact.lastName'),
        get(this.value, 'contact.firstName'),
        get(this.value, 'contact.middleName')
      ].filter(Boolean).join(' ')
      const phoneNumber = get(this.value, 'contact.phone')

      return [ fullName, phoneNumber ].filter(Boolean).join(', ')
    },

    items() {
      const result = []
      if (this.legalFormValue) {
        result.push({
          key: 'legalForm',
          label: this.getTranslate(`${Services.requisites}.labels.data.legal.opf`),
          value: this.legalFormValue
        })
      }
      if (this.taxNumberValue) {
        result.push({
          key: 'taxNumber',
          label: this.getTranslate(`${Services.requisites}.labels.data.legal.inn`),
          value: this.taxNumberValue,
          copy: true
        })
      }
      if (this.contactValue) {
        result.push({
          key: 'contact',
          label: this.getTranslate(`${Services.requisites}.labels.contact.title`),
          value: this.contactValue
        })
      }

      return result
    }
  },

  render
}
